import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_CLIENT_LOGO](store, clientLogo) {
    store.clientLogo = clientLogo;
  },
};
